export const EMPTY_VALUE: string = '\u2013'
